import { render } from "./past-workshop.vue?vue&type=template&id=261d0c9c&scoped=true"
import script from "./past-workshop.vue?vue&type=script&lang=js"
export * from "./past-workshop.vue?vue&type=script&lang=js"

import "./past-workshop.vue?vue&type=style&index=0&id=261d0c9c&scoped=true&lang=css"

import exportComponent from "/home/forge/test.rwandabuildprogram.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261d0c9c"]])

export default __exports__